import { render, staticRenderFns } from "./BCardActionsComments.vue?vue&type=template&id=51523294&scoped=true&"
import script from "./BCardActionsComments.vue?vue&type=script&lang=js&"
export * from "./BCardActionsComments.vue?vue&type=script&lang=js&"
import style0 from "./BCardActionsComments.vue?vue&type=style&index=0&id=51523294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51523294",
  null
  
)

export default component.exports